export default __webpack_public_path__ + "static/media/Centenary_Logo2.9488bc5b.png";